export default __webpack_public_path__ + "static/media/Prepare_For_School_3_2.074bc82b.png";